import Vue from 'vue'

export default function ({ app }) {
  // Add defensive wrappers for common async operations
  Vue.mixin({
    methods: {
      // Safe axios wrapper
      async $safeAxios(method, url, data = null, config = {}) {
        try {
          const result = method === 'get'
            ? await this.$axios?.$get(url, config)
            : method === 'post'
            ? await this.$axios?.$post(url, data, config)
            : method === 'put'
            ? await this.$axios?.$put(url, data, config)
            : method === 'delete'
            ? await this.$axios?.$delete(url, config)
            : await this.$axios[method](url, data, config);

          return result;
        } catch (error) {
          // Ensure we always deal with proper Error objects
          if (!(error instanceof Error)) {
            const properError = new Error(String(error) || 'Request failed');
            properError.originalError = error;
            throw properError;
          }
          throw error;
        }
      },

      // Safe router navigation
      async $safeRouterPush(location) {
        try {
          await this.$router?.push(location);
        } catch (error) {
          // Router navigation errors are often non-Error objects
          if (!(error instanceof Error)) {
            console.warn('Router navigation rejected with non-error:', error);
            // Don't throw for navigation "errors" that aren't actual errors
            if (error && (error.type === 'NavigationDuplicated' || error.name === 'NavigationDuplicated')) {
              return; // This is fine, user is already on this route
            }
            // For other non-errors, create a proper error
            const properError = new Error(`Navigation failed: ${String(error)}`);
            properError.originalError = error;
            throw properError;
          }
          throw error;
        }
      },

      // Safe async wrapper for any operation
      async $safeAsync(asyncFn, fallback = null) {
        try {
          return await asyncFn();
        } catch (error) {
          if (!(error instanceof Error)) {
            console.warn('Async operation rejected with non-error:', error);
            const properError = new Error(`Async operation failed: ${String(error)}`);
            properError.originalError = error;
            throw properError;
          }
          throw error;
        }
      }
    }
  });

  // Also wrap common global operations
  if (typeof window !== 'undefined') {
    // Wrap fetch if it exists
    if (window.fetch) {
      const originalFetch = window.fetch;
      window.fetch = async function(...args) {
        try {
          return await originalFetch.apply(this, args);
        } catch (error) {
          if (!(error instanceof Error)) {
            const properError = new Error(`Fetch failed: ${String(error)}`);
            properError.originalError = error;
            throw properError;
          }
          throw error;
        }
      };
    }
  }
}